// flawed "experiences"
export const EXPERIENCES = {
  CHECKOUT_DISABLED: 'Proceed to Checkout Disabled',
};

// flawed "reasons"
export const REASONS = {
  PRODUCT_SPEC_INVALID_TAG: 'Product Spec Invalid',
  PRICING_INVALID_TAG: 'Pricing Invalid',
  // flawed UX v1 usages only below; TODO remove
  CHECKOUT_DISABLED_TAG: 'Proceed to Checkout Disabled',
};
